import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import { useApiTrigger } from '../../hooks/useApiTrigger';

export function MultipleSelect({
    config,
    variables,
    values,
    handleChange,
    label = 'Seleccione...',
    name = '',
    required = false,
    error = false,
    errorText = 'Campo requerido'
}) {
    const [data, setData] = useState([]);
    const { getDataRequest } = useApiTrigger();
    useEffect(() => {
        const fetchOptions = async () => {
            if (config?.trigger) {
                const dto = await getDataRequest(config, variables);
                setData(dto);
            }
        };
        fetchOptions();
    }, []);

    const theme = useTheme();
    return (
        <>
            {data.length > 0 && values ? (
                <FormControl
                    fullWidth
                    size="small"
                    error={error}
                >
                    <Autocomplete
                        multiple
                        size="small"
                        id="multiple-autocomplete"
                        options={data}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        value={data.filter((item) => values.includes(item.code))}
                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    name: name,
                                    value: newValue.map((item) => item.code),
                                }
                            });
                        }}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    variant="filled"
                                    color="primary"
                                    label={option.name}
                                    {...getTagProps({ index })}
                                    size="small"
                                />
                            ))
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <span
                                    style={{
                                        fontWeight: selected ? 600 : 400,
                                        color: selected ? theme.palette.primary.main : 'inherit',
                                    }}
                                >
                                    {option.name}
                                </span>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                placeholder="Escribe para buscar"
                                required={required}
                                error={error}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                    />
                    {error && errorText && <FormHelperText>{errorText}</FormHelperText>}
                </FormControl>
            ) : (
                <Autocomplete
                    multiple
                    options={[]}
                    renderInput={(params) => (
                        <TextField {...params} label={label} />
                    )}
                />
            )}
        </>
    );
}
